<template>
  <div id="panel">
    <div id="dragIcon"></div>
    <div id="myicon">
      <Icon :type="isFull ? 'ios-arrow-up' : 'ios-arrow-down'" @click="puMan" />
      <Icon type="md-close" @click="close" />
    </div>

    <slot :mydata="height"></slot>
  </div>
</template>
<script>
export default {
  data() {
    return {
      height: 300,
      isFull: true,
    };
  },
  methods: {
    drag() {
      var oH = document.body.clientHeight;
      var oPanel = document.getElementById("panel");
      var oDragIcon = document.getElementById("dragIcon");
      // 定义4个变量
      var disY = 0; //鼠标按下时光标的Y值

      var that = this;
      //3. 给小div加点击事件
      oDragIcon.onmousedown = function (ev) {
        var ev = ev || window.event;
        disY = ev.clientY; // 获取鼠标按下时光标Y的值
        document.onmousemove = function (ev) {
          var ev = ev || window.event;
          if (ev.clientY <= 50) {
            return;
          }
          var H = oH - ev.clientY;
          if (H < 50) {
            return;
          }
          oPanel.style.height = H + "px"; // 拖拽后物体的高
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      };
      oDragIcon.onmouseup = function () {
        that.height = document.getElementById("panel").offsetHeight;
      };
    },
    puMan() {
      var oH = document.body.clientHeight;
      if (this.isFull) {
        document.getElementById("panel").style.height = oH - 50 + "px";
        this.height = oH - 50;
      } else {
        document.getElementById("panel").style.height = 300 + "px";
        this.height = 300;
      }
      this.isFull = !this.isFull;
    },
    close() {
      this.$emit("close");
    },
  },
  mounted() {
    this.drag();
  },
};
</script>
<style>
#panel {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 222;
  width: 100%;
  height: 300px;
  background: #fff;
  overflow: hidden;
}
#dragIcon {
  width: 100%;
  height: 10px;
  background: #fff;
  cursor: row-resize;
  border-top: 1px #999 double;
}
#myicon {
  font-size: 18px;
  float: right;
  margin-right: 10px;
  cursor: pointer;
}
#myicon i:hover {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/locus/drag.vue